import { API } from '../API';

export default class ContactManager {
  static async contact(data: any) {
    return await API.post(`contact/contact`, data);
  }
}
